import {Injectable} from '@angular/core';
import {HttpContext, HttpContextToken, HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {Router} from '@angular/router';
import {catchError} from 'rxjs/operators';

export const SKIP_NOTFOUND_REDIRECT = new HttpContextToken(() => false);

/**
 * Opts a request out of the app-wide 404→home redirect. Without it a 404 is swallowed here and the
 * caller's own `catchError` never runs — it sees the navigation result emitted as a success value.
 */
export const skipNotfoundRedirect = (): HttpContext => new HttpContext().set(SKIP_NOTFOUND_REDIRECT, true);

@Injectable()
export class NotfoundInterceptor implements HttpInterceptor {

  constructor(private router: Router) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<any> {
    return next.handle(request).pipe(catchError(error => {
      if (error instanceof HttpErrorResponse && error.status === 404 && !request.context.get(SKIP_NOTFOUND_REDIRECT)) {
        console.error(error);
        return this.router.navigateByUrl('/', {replaceUrl: true});
      }
      return throwError(error);
    }));
  }
}
